const Calendar = class Calendar {
    constructor(config) {

    }

    init(trigger) {
        let triggerCalendar = $(trigger);

        triggerCalendar.datepicker({
            format: "dd/mm/yyyy",
            autoclose: true
        });

    }
};

export {Calendar};


// WEBPACK FOOTER //
// ./static/js/components/Calendar.js